import { AccountInterface } from "../../../model/BookingModel";



export const getSelectedAccount = (accountList: AccountInterface[], id: number) => {
    const { accountId, accountName, blocked, subAccountBlocked } = accountList?.find((account: any) => account.subClientId === id) || {};
    return { accountId, accountName, blocked, subAccountBlocked }
}

//TODO:VAT Amount -  F + A *  VAT % / 100
export const calculateVATAmount = ({ freightCharge, additionalCharges = 0, vatPercentage }:
    { freightCharge: number, additionalCharges: number, vatPercentage: number }) => {
    const additionalAmount = ((+freightCharge) + (+additionalCharges));
    const calculatedAmount = (additionalAmount * (+vatPercentage)) / 100;
    return calculatedAmount || 0;
}

//TODO:VAT Amount -  F + A *  VAT % / 100
export const calculateVATAmountWith2Decimals = ({ freightCharge, additionalCharges = 0, vatPercentage }:
    { freightCharge: number, additionalCharges: number, vatPercentage: number }) => {
    const additionalAmount = ((+freightCharge) + (+additionalCharges));
    let calculatedAmount = (additionalAmount * (+vatPercentage)) / 100;
    // to round the value into 2 digit after the decimal.
    calculatedAmount = Math.round((calculatedAmount + Number.EPSILON) * 100) / 100
    return calculatedAmount || 0;
}


//TODO:Total Amount + F + In + Add + VAT Amt
export const calculateTotalAmount = ({ freightCharge, insurance, additionalCharges = 0, totalVATAmount }:
    { freightCharge: number, additionalCharges: number, insurance: number, totalVATAmount: number }) =>
    (+freightCharge) + (+insurance) + (+additionalCharges) + (+totalVATAmount)


//TODO: (Insurance Value * Insurance percentage)  /100 */
export const calculateInsuranceCharge = ({ insuranceValue, insurancePercentage }: { insuranceValue: number, insurancePercentage: number }) =>
    (+insuranceValue * +insurancePercentage) / 100;

export const calculateDryIceCharge = ({ dryIceQuantity }: { dryIceQuantity: number }) =>
    (+dryIceQuantity * 9 );

    export const calculateTotalMarkenCharges = (
        { dryIceQuantity = 0 , dryIceCharges = 0, transportationCharges = 0,
        airlineCharges = 0, fuelSecuritySurchargeCharge = 0, awbCharge = 0, otherCharge = 0, airportHandlingDo = 0,
        mofaicAttestationOfficialCharges = 0, calogiCharges = 0, customsClearence = 0, deliveryOrder = 0, bayan = 0,
        credoConditioningCharge = 0, dryIceReplinishment = 0
    }: { dryIceQuantity: number, dryIceCharges: number,transportationCharges: number,airlineCharges: number,
        fuelSecuritySurchargeCharge: number,awbCharge: number,otherCharge: number,airportHandlingDo: number,
        mofaicAttestationOfficialCharges: number,calogiCharges: number,customsClearence: number,deliveryOrder: number,
        bayan: number,credoConditioningCharge: number,dryIceReplinishment: number }) =>
    ((+dryIceQuantity) + (+dryIceCharges) +(+transportationCharges) +(+airlineCharges) +
    (+awbCharge) +(+otherCharge) +(+airportHandlingDo) +(+mofaicAttestationOfficialCharges) +(+fuelSecuritySurchargeCharge) +
    (+calogiCharges) +(+customsClearence) +(+deliveryOrder) +(+bayan) +(+credoConditioningCharge) +
    (+dryIceReplinishment));


    export const calculateTotalAmountWith2Decimals = ({ freightCharge, insurance, additionalCharges= 0, totalVATAmount }:
        { freightCharge: number, additionalCharges: number, insurance: number, totalVATAmount: number }) => {
            let calculatedAmount =   (+freightCharge) + (+insurance) + (+additionalCharges) + (+totalVATAmount);
                // to round the value into 2 digit after the decimal.
                calculatedAmount = Math.round((calculatedAmount + Number.EPSILON) * 100) / 100
                return calculatedAmount;
        }